export default __webpack_public_path__ + "static/media/login-img.3bb43a96.jpg";